import React from 'react';
import { useStore } from '../../../store/index';
import { formatDateMMDDYYYY } from '../../../utils/formatters';
import ProfileInviteCandidateButton from './ProfileInviteCandidateButton';
import { generateImageSource } from '../../../utils/generateImageSource';
import MobileDashboardSorting from '../../../components/common/MobileDashboardSorting/MobileDashboardSorting';

const sortOptions = [
  { headerText: 'Job Posting Title: A to Z', sort: { by: 'title', order: 'asc' } },
  { headerText: 'Job Posting Title: Z to A', sort: { by: 'title', order: 'desc' } },
  { headerText: 'Date Posted: Most Recent First', sort: { by: 'postedDate', order: 'desc' } },
  { headerText: 'Date Posted: Oldest First', sort: { by: 'postedDate', order: 'asc' } },
  {
    headerText: 'Number of Applicants: Low to High',
    sort: { by: 'applicantCount', order: 'asc' }
  },
  {
    headerText: 'Number of Applicants: High to Low',
    sort: { by: 'applicantCount', order: 'desc' }
  }
];

const MobileInviteCandidateTable = () => {

  const {
    bulkJobInvitationStore: {
      jobPostings,
      sort,
      setSort,
      selectedJobIds,
      removeSelectedJob,
      addSelectedJob
    }
  } = useStore();

  const renderSortingBlock = () => {
    return (
      <div className="my-dashboard__sorting-block" style={{ padding: '15px 10px' }}>
        <MobileDashboardSorting
          placeholder="Sort Job Postings"
          testId="job-postings-mobile-sort-dropdown"
          options={sortOptions}
          setSort={setSort}
          sort={sort}
        />
      </div>
    );
  };

  const MobileJobPostingListItem = ({ jobPosting }) => {

    let selected = false;
    if (Array.isArray(selectedJobIds) && selectedJobIds.length) {
      selected = selectedJobIds.includes(jobPosting.jobPostingId);
    }

    return (
      <div className="p2p-job-postings__list-item">
        <div className="p2p-job-postings__list-item-row">
          <div className="p2p-job-postings__list-item-orange-title">
            {jobPosting.title}
          </div>
          {selected && (
            <img
              src={generateImageSource('/images/v1/path-to-pro/success_icon_green.svg')}
            />
          )}
        </div>
        <div className="p2p-job-postings__list-item-row">
          <div className="p2p-job-postings__list-item-col">
            <span>Posted: </span>
            <span>{jobPosting.postedDate ? formatDateMMDDYYYY(jobPosting.postedDate) : '-'}</span>
          </div>
          <div className="p2p-job-postings__list-item-col" style={{ fontWeight: 'bold' }}>
            <span>Applicants: {jobPosting.applicantCount}</span>
          </div>
        </div>
        <div className="p2p-job-postings-invite-candidate__button-container">
          <ProfileInviteCandidateButton
            invitable={!jobPosting.candidateExistsInApplicants}
            addJob={addSelectedJob}
            removeJob={removeSelectedJob}
            jobId={jobPosting.jobPostingId}
            selected={selected}
          />
        </div>
      </div>
    );
  };

  return (
    <div className="p2p-job-postings-invite-candidate__mobile-table">
      {renderSortingBlock()}
      <div className="p2p-job-postings__items-list">
        {jobPostings.map((row, index) => (
          <MobileJobPostingListItem jobPosting={row} key={index} />
        ))}
      </div>
    </div>
  );
};

export default MobileInviteCandidateTable;
